// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3YmMI","insightsList":"newBusinessInsightsMenu_insightsList__2efT5","active":"newBusinessInsightsMenu_active__1Vl4p"};